import Cookies from "js-cookie";
import { AUTH_COOKIE_NAME, cookieOptions } from "../constants";
/** Get authentication state */
export function getAuthState() {
    try {
        const cookie = Cookies.get(AUTH_COOKIE_NAME);
        const state = cookie ? JSON.parse(cookie) : undefined;
        return state;
    }
    catch (_a) {
        return undefined;
    }
}
/** Get OneLogin access token from the authentication state */
export function getOneLoginToken() {
    var _a;
    return (_a = getAuthState()) === null || _a === void 0 ? void 0 : _a.accessToken;
}
/** Get CoachServer access token from the authentication state */
export function getCoachServerToken() {
    var _a, _b;
    return (_b = (_a = getAuthState()) === null || _a === void 0 ? void 0 : _a.coachServer) === null || _b === void 0 ? void 0 : _b.accessToken;
}
/** Select user profile from state */
export function formatUserProfile(state) {
    const { name, email, useCSAuth = true, accessToken: olAccessToken, coachServer, } = state;
    if (useCSAuth && coachServer) {
        return {
            name,
            email,
            accessCode: coachServer.accessCode,
            accessToken: coachServer.accessToken,
        };
    }
    // The accessCode as empty string is a hack to support auth without CoachServer, without a major type refactor
    return { name, email, accessCode: "", accessToken: olAccessToken };
}
/** Create Authorization header from token */
export function createAuthorizationHeaderFromToken(token) {
    return `bearer ${token}`;
}
/** Authorization header for CoachServer API requests */
export function getAuthorizationHeader() {
    var _a;
    const csToken = getCoachServerToken();
    const olToken = getOneLoginToken();
    const { useCSAuth } = (_a = getAuthState()) !== null && _a !== void 0 ? _a : {};
    const token = useCSAuth ? csToken : olToken;
    return token ? createAuthorizationHeaderFromToken(token) : undefined;
}
/**
 * Current logged in user profile
 * */
export function getActiveUser() {
    const state = getAuthState();
    return state ? formatUserProfile(state) : undefined;
}
/**
 *  Set authentication state cookie
 *  Only to be used in testing
 * */
export function setAuthState(state) {
    Cookies.set(AUTH_COOKIE_NAME, JSON.stringify(state), cookieOptions);
}
/**
 * Check it the currently logged in user is a Noom user
 */
export function isNoomUser(authState) {
    return (!authState.useOneLoginAuth &&
        (authState.useCSAuth || authState.useAutoCookieAuth) &&
        !!authState.state);
}
/**
 * Check it the currently logged in user is a Noom employee
 */
export function isNoomEmployee(authState) {
    return authState.useOneLoginAuth && !!authState.state;
}
//# sourceMappingURL=auth.js.map